import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ERR_EXISTING_COUNTRY } from "../../utils/errorLiterals";
import { ReactComponent as DeleteIcon } from "@deere/ux.brand-foundations/icons/delete.svg";
import { Modal, ModalActions, ModalContent, ModalTitle, Button, SelectField, Option, Grid, Table, TableBody, TableRow, TableCell, IconButton } from "@deere/fuel-react";
import { Typography } from "@mui/material";
import { getTranslation } from "../../utils/utils";

const ModalMultiCountry = ({ show, handleClose, popupCellParams, changeHandler }) => {
  const { t } = useTranslation();
  const countryList = useSelector((state) => state.surveyPartReducer.countryList);
  const [error, setError] = useState(false);
  const [countryInput, setCountryInput] = useState("");
  const [addedCountries, setAddedCountries] = useState([]);

  useEffect(() => {
    if (popupCellParams && popupCellParams.rowParams && popupCellParams.rowParams.value && addedCountries.length === 0) {
      setAddedCountries(popupCellParams.rowParams.value.split(", "));
    }
  }, [popupCellParams]);

  const countryAddHandler = () => {
    if (addedCountries.includes(countryInput)) {
      setError(ERR_EXISTING_COUNTRY);
      setCountryInput("");
    } else {
      setAddedCountries((prevState) => {
        return [...prevState, countryInput];
      });
      setError("");
      setCountryInput("");
    }
  };

  const submitHandler = () => {
    let value = "";
    addedCountries.forEach((cntry, index) => {
      index === addedCountries.length - 1 ? (value += cntry) : (value += `${cntry}, `);
    });
    changeHandler(popupCellParams.rowParams.id, [{ fieldName: popupCellParams.rowParams.field, value: value }]);
    closeModal();
  };

  const closeModal = () => {
    setError("");
    setCountryInput("");
    setAddedCountries([]);
    handleClose();
  };

  return (
    <Modal open={show} onClose={closeModal} fullWidth>
      <ModalTitle>
        <Grid container direction="column">
          <Grid item>
            <Typography variant="h2">{getTranslation(popupCellParams?.currentQue, "text")}</Typography>
          </Grid>
          <Grid item>
            <Typography sx={{ whiteSpace: "pre-line" }}>{getTranslation(popupCellParams?.currentQue, "helpText")}</Typography>
          </Grid>
        </Grid>
      </ModalTitle>
      <ModalContent dividers>
        <Grid container spacing={2}>
          <Table size="small">
            <TableBody>
              {addedCountries.map((cntry) => {
                return (
                  <TableRow>
                    <TableCell width={"80%"}>{cntry}</TableCell>
                    <TableCell>
                      <IconButton onClick={() => setAddedCountries((prevState) => prevState.filter((item) => item !== cntry))}>
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <Grid item xs={10}>
            <SelectField fullWidth value={countryInput} onChange={(e) => setCountryInput(e.target.value)}>
              <Option value="" sx={{ fontSize: "10px" }}>
                {t("lbl_dropdown_select")}
              </Option>
              {countryList.map((country) => {
                return (
                  <Option key={country.name} value={country.name} sx={{ fontSize: "10px" }}>
                    {country.name}
                  </Option>
                );
              })}
            </SelectField>
          </Grid>
          <Grid item xs={2}>
            <Button variant="secondary" onClick={countryAddHandler} disabled={countryInput === ""}>
              {t("btn_add")}
            </Button>
          </Grid>
          {error !== "" && (
            <Grid item alignItems={"flex-end"} style={{ color: "red", fontSize: "smaller" }}>
              {error}
            </Grid>
          )}
        </Grid>
      </ModalContent>
      <ModalActions>
        <Button variant="secondary" onClick={closeModal}>
          {t("btn_cancel")}
        </Button>
        <Button variant="primary" onClick={submitHandler} disabled={addedCountries.length === 0}>
          {t("btn_save_survey")}
        </Button>
      </ModalActions>
    </Modal>
  );
};

export default ModalMultiCountry;
